import { useStore } from '@tanstack/react-store';

import type { Mode, Theme } from '../store/theme';

import { themeStore } from '../store/theme';

export function useTheme() {
    const themeState = useStore(themeStore);

    function setTheme(theme: Theme) {
        themeStore.setState(state => ({ ...state, theme }));
    };

    function setMode(mode: Mode) {
        themeStore.setState(state => ({ ...state, mode }));
    };

    return {
        ...themeState,
        setTheme,
        setMode,
    };
}
